<style scoped lang='less'>
    .foot{
        background-color: #fff;
        position: relative;
        height:380px;
        .brand,.ad{
            position: absolute;
            top:70px;
            left: 140px;
        }
        .logo{
            line-height: 88px;
            margin-bottom: 18px;
            color:#333;
            font-size:14px;
            img{
                float: left;
                margin-right:20px;
            }
        }
        .ad{
            left: 680px;
        }
        p{
            font-size: 14px;
            color: rgb(51, 51, 51);
            line-height: 2.58;
        }
        .copyright{
          background:url('../assets/copyicon.png') center left;
          background-size:15px 15px;
          background-repeat:no-repeat;
          padding-left:20px;
          margin-left:10px;
        }
        .copyright a:hover{
          text-decoration: underline;
        }
        a{
            color: rgb(51, 51, 51);
            text-decoration: none;
            cursor: pointer;
        }
        .follow{
            font-size: 14px;
            color: rgb(51, 51, 51);
            margin-top:8px;
            span{
                float:left;
            }
            .wb{
                width:20px;
                height:16px;
                display: inline-block;
                margin:2px 0px 0px 15px;
                background:url('../assets/wb.png');
                background-size:20px 16px;
                &:hover{
                    background:url('../assets/wb-hover.png');
                    background-size:20px 16px;
                };
            }
        }
    }
</style>

<script>
const URLTYPE = {
    igetget: {
        recordation: '京ICP备15037205号-2',
        recordcode: '京公网安备 11010502034003号',
        recordcodeUrl: 'https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010502034003',
        company: '得到（天津）文化传播有限公司',
        copyright: 'Copyright © 2019 All rights reserved',
    },
    igetup: {
        recordation: '津ICP备17003455号',
        recordcode: '',
        recordcodeUrl: '',
        company: '得到（天津）文化传播有限公司',
        copyright: '2019 © All Rights Reserved',
    },
};

export default {
    data() {
        return {
            data: {},
        };
    },
    created() {
        if (/igetup/.test(window.location.host)) {
            this.data = URLTYPE.igetup;
        } else {
            this.data = URLTYPE.igetget;
        }
    },
};

</script>

<template>
    <div class="foot page">
        <div class="inner">
            <div class="brand">
                <div class="logo">
                    <img src="../assets/foot-logo-new.png" height="88" width="88" />
                    知识就在得到
                </div>
            <p>客服电话: 400-0526-000</p>
            <p>邮箱: <a href="mailto:iget@luojilab.com">iget@luojilab.com</a></p>
            <p>联系地址: 北京市朝阳区华贸商务楼20号楼</p>
            <div class="follow">
                <span>关注我们: </span>
                <a href="http://weibo.com/u/5745019302?topnav=1&wvr=6&topsug=1&is_all=1" class='wb'/>
            </div>
        </div>
        <div class="ad">
            <div class='logo'>
                <img src="../assets/gzh.png" height="88" width="88">
                微信扫码  关注「得到」公众号
            </div>
            <p>{{data.recordation}}<span class="copyright" v-if="data.recordcode">{{data.recordcode}}</span></p>
            <p>出版物经营许可证  新出发津零字第V065号</p>
            <p>营业执照 91120116MA05JPR99J</p>
            <p>{{data.company}}</p>
            <p>{{data.copyright}}</p>
            </div>
        </div>
    </div>
</template>



// WEBPACK FOOTER //
// Footer.vue?50a71dc5